import script from "./VersionEasterEgg.vue?vue&type=script&setup=true&lang=js"
export * from "./VersionEasterEgg.vue?vue&type=script&setup=true&lang=js"

import "./VersionEasterEgg.vue?vue&type=style&index=0&id=4ee0ff27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ee0ff27"]])

export default __exports__